import React from "react";
import "./CompanyInformation.scss";
import { CompanyInformationIState } from "./CompanyInformation.models";
import CartImage from "../../../assest/images/card-image/ItemAvatar09.png";
import StaticContentService from "../../../services/system/StaticContentService";

export default class CompanyInformation extends React.PureComponent<
  {},
  CompanyInformationIState
> {
  staticContentService: StaticContentService;
  constructor(props: any) {
    super(props);
    this.staticContentService = new StaticContentService();
    this.state = {
      companyInformation: {
        title: "",
        value: "",
      },
    };
  }

  componentDidMount() {
    this.staticContentService.getCompanyInformation().then((response) => {
      this.setState({
        companyInformation: response,
      });
    });
  }

  render(): React.ReactNode {
    let { companyInformation } = this.state;
    return (
      <>
        <div className="tk-card" style={{ padding: "38px" }}>
          <div className="tk-inline">
            <div className="icon">
              <img src={CartImage} width="64" height="64" alt="" />
            </div>
            <div className="pr-5">
              <label style={{fontSize: '16px'}}>{companyInformation.title}</label>
            </div>
          </div>
          <div className="institution-info" style={{ padding: "10px" }}>
            <label
              dangerouslySetInnerHTML={{
                __html: companyInformation.value ?? "",
              }}
            ></label>
          </div>
        </div>
      </>
    );
  }
}
